<template>
  <!-- Ad Type 3 - Small bottom-right notification (outside modal overlay) -->
  <AdPopUpModalSmall v-if="adType === 3" @close="close" :showExclamation="true">
    <template v-slot:header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="fs-4 fw-bold" v-html="adCode || 'CrimeTime Update'"></div>
        <button class="btn btn-gray btn-sm" @click="close">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>

    <template v-slot:body>
      <div class="fs-7 mb-2" v-html="vhtmlContent"></div>
      <img v-if="imageUrl" :src="imageUrl" style="width: 100%; height: auto; border-radius: 5px" />
    </template>
  </AdPopUpModalSmall>

  <!-- AdType 1: Main Modal to show Whats new in CrimeTime message -->
  <Modal v-else-if="adType === 1" size="large" @close="close" class="ad-modal">
    <template v-slot:header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div style="width: 38px"></div>
        <div class="fs-3 fw-bold text-center flex-grow-1 pr-5" v-html="adCode || 'CrimeTime Update'"></div>
        <button class="btn btn-gray btn-xl" @click="close">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>

    <template v-slot:body>
      <div class="p-3">
        <div class="fs-5 mb-5" v-html="vhtmlContent"></div>
        <img
          v-if="imageUrl"
          :src="imageUrl"
          style="width: 400px; max-width: 100%; height: auto; border: 1px solid black; border-radius: 10px"
        />
      </div>
    </template>
  </Modal>

  <!-- AdType 2: Modal with orange border -->
  <Transition v-else-if="adType === 2" name="modal-fade">
    <div class="modal-tom" @click="close">
      <div class="modal-content" @click.stop>
        <!-- style="border: 3px solid #ff6b35" -->
        <header class="modal-header orange-header">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div style="width: 38px"></div>
            <div class="fs-3 fw-bold text-center flex-grow-1" v-html="adCode || 'CrimeTime Update'"></div>
            <button class="btn btn-gray btn-xl" @click="close">
              <i class="fa fa-close"></i>
            </button>
          </div>
        </header>
        <section class="modal-body scrollbar">
          <div class="p-3">
            <div class="fs-5 mb-5" v-html="vhtmlContent"></div>
            <img
              v-if="imageUrl"
              :src="imageUrl"
              style="width: 400px; max-width: 100%; height: auto; border: 1px solid black; border-radius: 10px"
            />
          </div>
        </section>
      </div>
    </div>
  </Transition>
</template>

<script>
import Modal from "@/components/utils/Modal.vue";
import AdPopUpModalSmall from "@/components/utils/AdPopUpSmall.vue";
import axios from "axios";

export default {
  name: "AdPopUpModal",
  components: { Modal, AdPopUpModalSmall },
  props: {
    vhtmlContent: { type: String, default: "" },
    imageUrl: { type: String, default: "" },
    adCode: { type: String, default: "" },
    adType: { type: Number, default: 0 },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    async dismissAd() {
      try {
        await axios.delete(`${process.env.VUE_APP_ENDPOINT}/api/JWTUser/turnOffAdForUser`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
      } catch (err) {
        console.error("Error turning off ad:", err);
      } finally {
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
.orange-exclamation-circle i {
  margin: 0;
  font-size: 40px;
}

.orange-exclamation-circle {
  position: absolute;
  top: calc(100% - -100px);
  left: 190%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  background-color: #ff6b35;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(255, 107, 53, 0.3);
  z-index: 50;
}

strong {
  color: var(--button) !important;
}

.blue-color {
  color: var(--button);
}

.ad-modal :deep(.modal-header) {
  background-color: var(--button) !important;
  color: white;

  /* border-radius: 0; */
}

.ad-modal :deep(.modal-content) {
  border-left: 15px solid var(--button) !important;
  border-right: 15px solid var(--button) !important;
  border-bottom: 15px solid var(--button) !important;
  border-top-left-radius: 25px !important;
  border-top-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  border-bottom-right-radius: 25px !important;
}
</style>
